import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import BranchTeamActions from "./widget/BranchTeamActions";
import BranchTeamContent from "./BranchTeamContent";
import { BranchTeamContextProvider } from "../../../provider/branch/branch_team/BranchTeamContextProvider";
import { HomeContextProvider } from "../../../provider/home/HomeContextProvider";

const BranchTeamScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <HomeContextProvider>
      <BranchTeamContextProvider>
        <Scaffold
          appBarTitle={AppTranslation.text("team_members")}
          appBarAction={<BranchTeamActions />}
        >
          <MainBodyContainer className="h-100">
            <BranchTeamContent type={type} isModal={false} />
          </MainBodyContainer>
        </Scaffold>
      </BranchTeamContextProvider>
    </HomeContextProvider>
  );
};

export default BranchTeamScreen;
export const routeName: string = "/branch-team";
